<template>
    <li @click="chatStore.selectChat(group.id)"
        @contextmenu.prevent="openMenu"
        :class="{ 'active': isActive }"
        class="chat-item overflow-hidden">

        <div class="chat-item-wrapper d-flex w-100 position-relative"
            :style="{ transform: `translateX(${swipeOffset}px)`, transition: isSwiping ? 'none' : 'transform 0.2s ease-out' }"
            @touchstart="onTouchStart" 
            @touchmove="onTouchMove" 
            @touchend="onTouchEnd"
        >

            <a class="cursor-pointer chat-link flex-shrink-0 w-100">

                <div class="d-flex align-items-start relative-container">

                    <div class="me-3 ms-0 align-self-center position-relative">
                        <!-- Comunidade: miniatura que "espia" por trás do avatar, como no
                             WhatsApp. Canto superior ESQUERDO de propósito — o direito já é
                             usado pelo cadeado de grupo restrito. -->
                        <!-- No grupo de avisos o selo só sai quando o avatar principal JÁ é a
                             foto da comunidade — aí ele repetiria a mesma imagem. Sem essa
                             foto (a resolução é em segundo plano e pode falhar) o avatar cai
                             no do próprio grupo, e sem o selo o item ficaria indistinguível
                             de um grupo solto. -->
                        <div v-if="group.comunidade && !ehComunidadeNaLista"
                            class="comunidade-badge"
                            :title="`Comunidade: ${group.comunidade.nome}`">
                            <img v-if="group.comunidade.avatar && !comunidadeImagemFalhou"
                                :src="group.comunidade.avatar"
                                :alt="group.comunidade.nome"
                                loading="lazy"
                                @error="comunidadeImagemFalhou = true" />
                            <i v-else class="ri-group-2-fill"></i>
                        </div>

                        <!-- Cantos arredondados quando o item representa a comunidade: é o
                             que a distingue de um grupo na interface do WhatsApp. -->
                        <div class="avatar-wrapper" :class="{ 'avatar-comunidade': ehComunidadeNaLista }">
                            <AvatarField
                                :foto="group.avatar"
                                :is-group="true"
                                class="avatar-xs"
                                style="width: 45px !important; height: 45px !important;" 
                                loading="lazy"
                            />
                        </div>

                        <!-- Megafone SOBRE a foto, canto inferior direito: é como o WhatsApp
                             marca o grupo de avisos de uma comunidade. Fica por cima do
                             avatar (ao contrário da miniatura da comunidade, que espia por
                             trás) e substitui o selo genérico de grupo mais abaixo — o
                             megafone já diz que é grupo, e diz qual. -->
                        <div v-if="group.ehGrupoAvisos" class="avisos-badge" title="Avisos da comunidade">
                            <i class="ri-megaphone-fill"></i>
                        </div>

                        <div v-if="showBadgeGrupoSensivel" class="group-badge group-badge-top" title="Grupo com conteúdo sensível">
                            <i class="ri-lock-fill"></i>
                        </div>

                        <div v-if="uiStore.activeListTab !== 'grupos' && !hideBadge && !group.ehGrupoAvisos" class="group-badge" title="Grupo">
                            <i class="ri-group-fill"></i>
                        </div>
                    </div>

                    <div class="flex-grow-1 overflow-hidden me-2 align-self-center content-area" style="min-width: 0;">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <h5 class="text-truncate font-size-15 mb-0 chat-name d-block w-100">{{ group.name }}</h5>
                        </div>

                        <div v-if="group.tags && group.tags.length > 0"
                            class="d-flex align-items-center flex-wrap gap-1 mb-1">
                            <template v-for="tag in group.tags" :key="tag.nome">
                                <div class="tag-clean-pill"
                                    :style="{ '--tag-color': tag.cor, backgroundColor: tag.cor + '0D' }">
                                    <span class="tag-dot-solid" :style="{ backgroundColor: tag.cor }"></span>
                                    <span class="tag-name">{{ tag.nome }}</span>
                                </div>
                            </template>
                        </div>

                        <p class="chat-user-message text-truncate mb-0" :title="group.lastMessage.text">
        
                            <span v-if="presencaDigitando" class="text-success">
                                {{ presencaDigitando.texto }}
                            </span>
                            <span v-else-if="chatStore.draftsDict[group.id] && chatStore.activeChatId !== group.id" >
                                <span class="text-draft" >Rascunho:</span> {{ chatStore.draftsDict[group.id] }}
                            </span>
                            <template v-else>
                                <template v-if="showMessageStatus">
                                    <template v-if="group.lastMessage.status == 'read'">
                                        <i class="ri-check-double-line me-1" style="color: #50a5f1"></i>
                                    </template>
                                    <template v-else-if="group.lastMessage.status == 'delivered'">
                                        <i class="ri-check-double-line me-1"></i>
                                    </template>
                                    <template v-else>
                                        <i class="ri-check-line me-1"></i>
                                    </template>
                                </template>
                                <strong v-if="getLastMessageSender">
                                    {{ getLastMessageSender }}:
                                </strong>
                                <i v-if="group.lastMessage.type === 'sticker'" class="ri-sticky-note-fill align-middle me-1 ms-0 text-primary"><strong class=""> Figurinha</strong></i>
                                <span v-else><i v-if="iconeDoTipo" :class="iconeDoTipo"></i>{{ signaturelessText }}</span>
                                
                            </template>
                        </p>
                    </div>

                    <div class="chat-meta-column flex-shrink-0">
                        <span class="font-size-11 chat-time text-nowrap"
                            :class="{ 'text-unread': group.unreadCount > 0 || group.isMarkedUnread }">
                            {{ FormatTime(group.time) }}
                        </span>

                        <div class="d-flex align-items-center justify-content-end mt-1 action-row">

                            <span v-if="group.unreadCount > 0" class="unread-badge">
                                {{ unreadLabel }}
                            </span>
                            <span v-else-if="group.isMarkedUnread" class="unread-dot me-1" v-tooltip="'Marcado como não lido'"></span>

                            <i v-if="group.isPinned" class="ri-pushpin-fill text-muted font-size-14 ms-1"></i>
                            <i v-if="silenciado" class="ri-volume-mute-fill text-muted font-size-14 ms-1" v-tooltip="'Grupo silenciado'"></i>

                            <div class="action-trigger-wrapper">
                                <VDropdown :distance="6" placement="bottom-end" ref="dropdownRef">
                                    <button type="button" class="btn btn-link p-0 chat-actions-btn" @click.stop title="Mais Ações">
                                        <i class="ri-more-2-fill"></i>
                                    </button>
                                    <template #popper>
                                        <div class="dropdown-menu-v">
                                            <a v-permission="['conta.inserir_etiquetas']" href="#" class="dropdown-item-v" v-close-popper @click.stop="handleLinkTagClick(group)">
                                                <i class="ri-price-tag-3-line me-2"></i> Adicionar etiqueta
                                            </a>

                                            <a href="#" class="dropdown-item-v" @click.stop="handleTogglePin(props.group)">
                                                <i :class="props.group.isPinned ? 'ri-unpin-line' : 'ri-pushpin-line'" class="me-2"></i>
                                                {{ props.group.isPinned ? 'Desafixar' : 'Fixar' }}
                                            </a>

                                            <a href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleToggleMute(props.group)">
                                                <i :class="silenciado ? 'ri-notification-3-line' : 'ri-notification-off-line'" class="me-2"></i>
                                                {{ silenciado ? 'Reativar notificações' : 'Silenciar' }}
                                            </a>

                                            <a v-if="group.unreadCount === 0 && !group.isMarkedUnread" href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleMarkAsUnread(props.group)">
                                                <i class="ri-mail-unread-line me-2"></i> Marcar como não lido
                                            </a>
                                            <a v-else href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleMarkAsRead(props.group)">
                                                <i class="ri-mail-open-line me-2"></i> Marcar como lido
                                            </a>

                                            <div v-permission="{perms: 'inbox.apagar_grupos', idInbox: group.idInbox}" class="dropdown-divider-v"></div>

                                            <a v-permission="{perms: 'inbox.apagar_grupos', idInbox: group.idInbox}" @click="apagarGrupo" style="min-width: 150px" class="dropdown-item-v text-danger">
                                                <template v-if="isDeleting">
                                                    <i class="ri-loader-4-line me-2 spinisplendi"></i> Apagando...
                                                </template>
                                                <template v-else>
                                                    <i class="ri-logout-box-r-line me-2"></i> Apagar grupo
                                                </template>
                                            </a>

                                            <!-- <a href="#" class="dropdown-item-v text-danger">
                                                <i class="ri-logout-box-r-line me-2"></i> Sair do grupo
                                            </a> -->
                                        </div>
                                    </template>
                                </VDropdown>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="chatStore.initialized && group.idInbox"
                    class="instance-corner-badge" 
                    :style="{ backgroundColor: cornerBadgeBg }"
                    :title="nomeInbox">
                    {{ nomeInbox }}
                </div>

            </a>

            <div class="swipe-actions d-lg-none position-absolute top-0 d-flex align-items-center justify-content-end h-100 pe-2"
                style="right: -140px; width: 140px;">
                <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="handleLinkTagClick(group); swipeOffset = 0">
                    <i class="ri-price-tag-3-line text-primary"></i>
                </button>
                <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop.prevent="handleTogglePin(group); swipeOffset = 0">
                    <i :class="group.isPinned ? 'ri-unpin-line' : 'ri-pushpin-line'" class="text-warning"></i>
                </button>
                <button class="btn btn-sm btn-danger rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="apagarGrupoMobile">
                    <i class="ri-delete-bin-line"></i>
                </button>
            </div>
        </div>
    </li>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import { rotuloPresenca, useChatStore } from '@/stores/app/chatStore';
import { useUiStore } from '@/stores/app/uiStore';
import { hideAllPoppers, vClosePopper } from 'floating-vue';
import AvatarField from '@/components/global/AvatarField.vue';
import { FormatTime, grupoEstaSilenciado, pastelColorFromString, TextContentUtil } from '@/stores/app/chatUtils';
import { PromptToAlternarSilencioGrupo } from '@/components/app/swal/SilenciarGrupo';
import { getIconClassFromType } from '@/services/mensagens/mensagens.service';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { Chat } from '@/mocks/app/mockChatData';
import { IdGrupo } from '@/services/common-types';
import { delay } from '@/utils/delay';
import { formatUnreadCount } from '@/utils/formatUnreadCount';
FormatTime;

const props = defineProps({
    group: {
        type: Object as PropType<Chat>,
        required: true
    },
    hideBadge: {
        type: Boolean,
        default: false
    }
});

const showBadgeGrupoSensivel = computed(() => props.group.isWhitelistEnabled);

/**
 * O item representa a comunidade, não um grupo comum.
 *
 * Só vale quando há foto da comunidade para mostrar: sem foto, o avatar cai no do
 * próprio grupo (ou nas iniciais) e deixar o quadrado prometeria uma identidade que
 * não está ali.
 */
const ehComunidadeNaLista = computed(
    () => !!props.group.ehGrupoAvisos && !!props.group.comunidade?.avatar,
);

/**
 * A foto da comunidade é uma URL da plataforma e pode expirar. Sem este estado, a
 * falha viraria um ícone de imagem quebrada colado no avatar.
 */
const comunidadeImagemFalhou = ref(false);

/** Badge de não lidas: acima de 99 vira "99+" para não esticar a pílula. */
const unreadLabel = computed(() => formatUnreadCount(props.group.unreadCount));

const authUser = useAuthStoreUser();
const chatStore = useChatStore();
const uiStore = useUiStore(); 

const nomeInbox = computed(() => chatStore.initialized && props.group?.idInbox ? chatStore.inboxMap.get(props.group.idInbox)?.nome : '');
const cornerBadgeBg = computed(() => props.group?.idInbox ? pastelColorFromString(props.group.idInbox) : '#fff');

// Substitui a linha de prévia enquanto um participante digita, no mesmo lugar do
// "Rascunho:". Em grupo o rótulo já vem nomeado pelo store.
const presencaDigitando = computed(() => rotuloPresenca(props.group, chatStore.contatosByCodigo));

const isActive = computed(() => {
    return chatStore.activeChatId === props.group.id;
});

const showMessageStatus = computed(() => props.group.lastMessage?.isFromMe ? true : false );
const signaturelessText = computed(() => TextContentUtil.extractNonSignature(props.group?.lastMessage?.text) ?? '');
// Texto da prévia vai por `{{ }}`, nunca `v-html`: é conteúdo do contato.
const iconeDoTipo = computed(() => getIconClassFromType(props.group.lastMessage?.ogType));
// group.lastMessage.sender || group.lastMessage.agent
const getLastMessageSender = computed(() => props.group.lastMessage.sender == authUser?.user?.nome || props.group.lastMessage.sender == 'Você' ? null : props.group.lastMessage?.sender)
const handleTogglePin = (group: Chat) => chatStore.togglePin(group.id);
const handleMarkAsUnread = (group: Chat) => chatStore.markAsUnread(group.id);
const handleMarkAsRead = (group: Chat) => chatStore.resolveMarkChatAsRead(group.id, true);
const handleToggleMute = (group: Chat) => PromptToAlternarSilencioGrupo(group, chatStore);
const silenciado = computed(() => grupoEstaSilenciado(props.group));

// Botão direito abre o mesmo menu dos três pontinhos, como no `ChatItem`.
const dropdownRef = ref<{ show: () => void } | null>(null);
function openMenu() {
    hideAllPoppers();
    dropdownRef.value?.show();
}

function handleLinkTagClick(group: Chat) {
    chatStore.setChatToLinkTags(group);
    uiStore.openLinkTagModal();
}

let isDeleting = ref(false);
async function apagarGrupo() {
    if (isDeleting.value) return;
    isDeleting.value = true
    await chatStore.deleteGroup(props.group.id as IdGrupo, props.group.idInbox);
    isDeleting.value = false;
}

// --- LÓGICA DE SWIPE MOBILE ---
const swipeOffset = ref(0);
const isSwiping = ref(false);
let startX = 0;
let startY = 0;
let isVerticalScroll = false;

function onTouchStart(e: TouchEvent) {
    if (window.innerWidth >= 992) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwiping.value = true;
    isVerticalScroll = false;
}

function onTouchMove(e: TouchEvent) {
    if (!isSwiping.value || isVerticalScroll || window.innerWidth >= 992) return;
    
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const diffX = currentX - startX;
    const diffY = currentY - startY;

    if (Math.abs(diffY) > Math.abs(diffX) && Math.abs(diffY) > 10) {
        isVerticalScroll = true;
        return;
    }

    if (diffX < 0) {
        e.preventDefault(); 
        const maxSwipe = -140;
        swipeOffset.value = Math.max(diffX, maxSwipe);
    } else if (diffX > 0 && swipeOffset.value < 0) {
        swipeOffset.value = Math.min(0, -140 + diffX);
    }
}

function onTouchEnd() {
    if (!isSwiping.value || window.innerWidth >= 992) return;
    isSwiping.value = false;
    
    const threshold = -50;
    const maxSwipe  = -140;
    
    if (swipeOffset.value < threshold) {
        swipeOffset.value = maxSwipe; 
    } else {
        swipeOffset.value = 0; 
    }
}

async function apagarGrupoMobile() {
    swipeOffset.value = 0;
    await apagarGrupo();
}
</script>

<style scoped>
.chat-item {
    margin-bottom: 2px;
}

.chat-link {
    position: relative;
    display: block;
    padding: 12px 10px;
    padding-bottom: 20px;
    border-radius: 12px;
    text-decoration: none !important;
    transition: background-color 0.2s ease;
    overflow: hidden;
    border: 1px solid transparent;
}

.chat-item:hover .chat-link {
    background-color: var(--bs-light);
}
.chat-item.active .chat-link {
    background-color: var(--bs-primary-bg-subtle);
}

.relative-container {
    position: relative;
    z-index: 2;
    min-height: 45px;
}

/* --- ESTILO DO BADGE DE GRUPO --- */
/* `:deep` porque `AvatarField` fixa `border-radius: 50%` no próprio estilo scoped —
   uma classe do pai não alcança a `img` de dentro dele sem isso. */
.avatar-wrapper.avatar-comunidade,
.avatar-wrapper.avatar-comunidade :deep(img),
.avatar-wrapper.avatar-comunidade :deep(.avatar-field) {
    border-radius: 14px;
}

/* Cerca de um quarto da ÁREA do avatar de 45px, como o WhatsApp desenha — e um quarto
   da área é metade da largura: `(d/45)² = 0,25` → `d ≈ 22px`. Ler os 25% como largura
   dava 11px e o selo sumia. Ancorado como o selo genérico que ele substitui, para o
   canto não "pular" entre um grupo e outro. */
.avisos-badge {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid var(--bs-white);
    background-color: var(--bs-white);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--bs-primary);
    font-size: 13px;
    /* ACIMA do avatar: o megafone marca a foto, não espia por trás dela. */
    z-index: 3;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

/* Sem variação em hover/ativo, de propósito. Os demais selos deste item ficam sobre o
   FUNDO DA LINHA e acompanham a cor dela para blendar; este fica sobre a FOTO, onde
   acompanhar a linha só apaga o disco e deixa o ícone solto na imagem. Fundo e anel
   ficam opacos e constantes. */

.comunidade-badge {
    position: absolute;
    /* Recuo limitado pelo `padding: 12px 10px` do `.chat-link`: passar de -10px na
       horizontal encosta na borda do item e o selo é cortado. */
    top: -6px;
    left: -8px;
    /* Dois terços do avatar de 45px. Em 22px o selo lia como um ícone de status
       qualquer; neste tamanho a foto da comunidade é reconhecível, que é o ponto. */
    width: 30px;
    height: 30px;
    /* Cantos arredondados, não círculo: é como a comunidade se distingue de um
       grupo na própria interface do WhatsApp. Raio acompanha o lado para manter a
       mesma proporção de canto. */
    border-radius: 10px;
    overflow: hidden;
    border: 2px solid var(--bs-white);
    background-color: var(--bs-light);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    font-size: 13px;
    /* Abaixo do avatar: a miniatura espia por trás, não cobre. */
    z-index: 1;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.comunidade-badge img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.chat-item:hover .comunidade-badge {
    border-color: var(--bs-light);
}

.chat-item.active .comunidade-badge {
    border-color: var(--bs-primary-bg-subtle);
}

.group-badge {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 20px;
    height: 20px;
    background-color: var(--bs-white); 
    border: 2px solid var(--bs-white); 
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d; 
    font-size: 11px;
    z-index: 5;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.group-badge.group-badge-top {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 20px;
    height: 20px;
    background-color: var(--bs-white); 
    border: 2px solid var(--bs-white); 
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d; 
    font-size: 11px;
    z-index: 5;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.chat-item:hover .group-badge {
    border-color: var(--bs-light); 
    background-color: var(--bs-light);
}

.chat-item.active .group-badge {
    border-color: var(--bs-primary-bg-subtle);
    background-color: var(--bs-primary-bg-subtle);
    color: var(--bs-primary);
}

[data-bs-theme=dark] .group-badge {
    background-color: #22272b;
    border-color: #22272b;
    color: #aebac1;
}

/* No escuro o disco precisa ser opaco pelo mesmo motivo: translúcido sobre a foto some.
   Também sem variação por estado da linha. */
[data-bs-theme=dark] .avisos-badge {
    border-color: var(--bs-body-bg);
    background-color: var(--bs-body-bg);
    color: var(--bs-primary);
}

[data-bs-theme=dark] .comunidade-badge {
    border-color: var(--bs-body-bg);
    background-color: rgba(255,255,255,0.06);
}

[data-bs-theme=dark] .chat-item:hover .comunidade-badge,
[data-bs-theme=dark] .chat-item.active .comunidade-badge {
    border-color: transparent;
}

[data-bs-theme=dark] .chat-item:hover .group-badge {
    background-color: rgba(255,255,255,0.03);
    border-color: transparent;
}

[data-bs-theme=dark] .chat-item.active .group-badge {
    background-color: rgba(var(--bs-primary-rgb), 0.15);
    border-color: transparent;
    color: var(--bs-primary);
}

/* Resto dos estilos mantidos */
.chat-meta-column {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    min-width: 65px; 
    margin-bottom: 12px;
}

.action-row {
    height: 20px;
    margin-top: 2px;
}

.instance-corner-badge {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 8px; 
    font-weight: 800;
    color: #fff;
    padding: 3px 12px 3px 14px; 
    border-top-left-radius: 12px;
    border-bottom-right-radius: 12px;
    z-index: 5; 
    box-shadow: -2px -2px 6px rgba(0,0,0,0.06);
    line-height: 1.1;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: help; 
    pointer-events: auto;
}

/* `border-radius: 50%` virava elipse assim que o contador passava de 1 dígito:
   o raio acompanha a largura. Raio absoluto + padding lateral dão círculo com
   1 dígito e pílula com "99+". Mesmos valores da ChatItem. */
.unread-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9999px;
    background-color: var(--bs-success);
    color: #fff;
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    margin-right: 4px;
    animation: pulse-green 1.5s infinite;
}

/* marcação manual "não lido": dot sem número (estilo WhatsApp) */
.unread-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--bs-success);
    animation: pulse-green 1.5s infinite;
}

@keyframes pulse-green {
    0% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(var(--bs-success-rgb), 0.7); }
    50% { transform: scale(0.8); opacity: 0.4; box-shadow: 0 0 0 0 rgba(var(--bs-success-rgb), 0); }
    100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 8px rgba(var(--bs-success-rgb), 0); }
}

.action-trigger-wrapper {
    width: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.25s ease;
    display: flex;
    justify-content: center;
}

.chat-item:hover .action-trigger-wrapper,
.chat-item.active .action-trigger-wrapper {
    width: 20px;
    opacity: 1;
}

.chat-actions-btn {
    color: var(--bs-gray-500);
    font-size: 18px;
    border: none;
    display: flex;
    align-items: center;
    line-height: 1;
    text-decoration: none !important;
}
.chat-actions-btn:hover { color: var(--bs-primary) !important; }
.chat-actions-btn:hover, 
.chat-actions-btn:focus, 
.chat-actions-btn:active { 
    color: var(--bs-primary);
    text-decoration: none !important; 
}

.chat-name { font-weight: 600; color: var(--bs-gray-900); }
.chat-time { color: var(--bs-gray-500); font-weight: 500; }
.chat-user-message { color: var(--bs-gray-600); font-size: 13.5px; }
.text-sender { color: var(--bs-gray-800); font-weight: 600; }

.avatar-wrapper {
    border-radius: 50%;
    padding: 2px;
    display: inline-block;
    /* Acima do selo de comunidade, para que a miniatura fique mesmo ATRÁS. */
    position: relative;
    z-index: 2;
}

[data-bs-theme=dark] .chat-name { color: #f8f9fa; }
[data-bs-theme=dark] .text-sender { color: #dee2e6; }
[data-bs-theme=dark] .chat-user-message { color: #adb5bd; }
[data-bs-theme=dark] .chat-time { color: #6c757d; }
[data-bs-theme=dark] .chat-link:hover { background-color: rgba(255,255,255,0.03); }
[data-bs-theme=dark] .chat-item.active .chat-link { background-color: rgba(var(--bs-primary-rgb), 0.15); }
[data-bs-theme=dark] .chat-actions-btn { color: #adb5bd; }

.tag-clean-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px 3px 5px;
    border-radius: 6px;
    font-size: 10.5px;
    font-weight: 600;
    background-color: var(--tag-bg, rgba(0,0,0,0.03));
    border: 1px solid transparent;
    cursor: default;
    max-width: 140px;
}
.tag-dot-solid {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 6px;
    flex-shrink: 0;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1);
}
.tag-name {
    color: var(--bs-gray-700);
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
}
[data-bs-theme=dark] .tag-clean-pill {
    background-color: rgba(255,255,255,0.04) !important;
    border-color: rgba(255,255,255,0.08) !important;
}
[data-bs-theme=dark] .tag-name { color: #ced4da; }
[data-bs-theme=dark] .tag-dot-solid { box-shadow: none; filter: brightness(1.2); }

.text-unread {
    color: var(--bs-success) !important;
    font-weight: 600; /* Opcional: deixa um pouco mais destacado junto com a cor */
}

.text-draft {
    color: var(--bs-success) !important;
    font-weight: 600;
}

.spinisplendi {
  display: inline-block; /* ensures transform works properly */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Oculta os botões padrão de hover do desktop no celular e cria fundo sólido no card */
@media (max-width: 991.98px) {
    .action-trigger-wrapper {
        display: none !important;
    }
    .chat-link {
        background-color: var(--bs-body-bg) !important;
    }
    [data-bs-theme="dark"] .chat-link {
        background-color: var(--bs-sidebar-sub-bg) !important;
    }
}
</style>